
// export const baseURL = `https://dev-telgros.jamsara.com/api`
// export const baseURL = `https://www.telgros.com/api`
export const baseURL = `https://portal.telgros.com/api`
// export const baseURL = `http://localhost:1221/api`
// export const SocketbaseURL = `http://localhost:1221/socket`
// export const SocketbaseURL = `http://192.168.29.107:1221/api`
// export const SocketbaseURL = `https://www.telgros.com/socket`
export const SocketbaseURL = `https://portal.telgros.com/socket`
